import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { AppsPriceFilterDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsPriceFilterDto } from "app/pages/sales-intelligence/store/find-apps/types";

type IAppsPriceFilterOptions = readonly number[];

export default class FindAppsPriceFilter
    extends FilterPanelBaseFilter<IAppsPriceFilterDto, AppsPriceFilterDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsPriceFilterDto, AppsPriceFilterDescriptionDto>
{
    readonly minOptions: IAppsPriceFilterOptions;
    readonly maxOptions: IAppsPriceFilterOptions;

    constructor(deps: IFilterPanelBaseFilterDeps<IAppsPriceFilterDto, AppsPriceFilterDescriptionDto>) {
        super(deps);

        const {
            options: { buckets },
        } = deps;

        this.minOptions = buckets.slice(0, buckets.length - 1);
        this.maxOptions = buckets.slice(1);
    }
}
